import { render, staticRenderFns } from "./OpenBankingWalletSettings.vue?vue&type=template&id=21488ec8&scoped=true"
import script from "./OpenBankingWalletSettings.vue?vue&type=script&lang=js"
export * from "./OpenBankingWalletSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21488ec8",
  null
  
)

export default component.exports